import React from 'react'
import BaseSelect from "./widgets/Dropdowns/BaseSelect";

export const BenefitNetworkSelect = ({ onChange, onError, registerMe = () => { }, valid, invalid, message, ...rest }) => {

    return (
        <BaseSelect
            serviceUrl={`benefitnetwork/items`}
            valueName="idBenefitNetwork"
            labelName="name"
            //initialValue="2"
            onChange={onChange}
            onError={onError}
            selectFirst={false}
            initialValue={3}
            invalid={invalid}
            valid={valid}
            registerMe={registerMe}
            message={message}
            {...rest}
        />
    )
}

export const ProviderSelect = ({ onChange, onError, registerMe = () => { }, locationUniqueId, valid, invalid, message, ...rest }) => {
    return (
        <BaseSelect
            serviceUrl={`clinic/${locationUniqueId}/providers/items`}
            valueName="uniqueID"
            labelName='fullName'
            titleId='idPrescribersTitle'
            onChange={onChange}
            onError={onError}
            selectFirst={false}
            invalid={invalid}
            valid={valid}
            registerMe={registerMe}
            message={message}
            {...rest}
        />
    )
}

export const InsurerSelect = ({ onChange, onError, registerMe = () => { }, locationUniqueId, valid, invalid, message, ...rest }) => {

    return (
        <BaseSelect
            serviceUrl={`clinic/${locationUniqueId}/insurers/items`}
            valueName="id"
            labelName="name"
            onChange={onChange}
            onError={onError}
            selectFirst={false}
            invalid={invalid}
            valid={valid}
            registerMe={registerMe}
            message={message}
            {...rest}
        />
    )
}

// export const NetworkBenifitOptionSelect = ({onChange, onError, ...rest}) => {

//   return (
//       <BaseSelect
//         serviceUrl={`provider/list/${locationUniqueId}`}
//         valueName="id"
//         labelName="name"
//         onChange={onChange}
//         onError={onError}
//         selectFirst={false}
//         {...rest}
//       />
//   )
// }